// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y3FQ8","col":"styles_col__24Lns","actions":"styles_actions__3q8Oa","conflict":"styles_conflict__1LT00"};